import { render } from "./Overview.vue?vue&type=template&id=4d7b6d5d&scoped=true&lang=true"
import script from "./Overview.vue?vue&type=script&lang=js"
export * from "./Overview.vue?vue&type=script&lang=js"

import "./Overview.vue?vue&type=style&index=0&id=4d7b6d5d&lang=scss&scoped=true"

import exportComponent from "/var/lib/buildkite-agent/builds/BKxAWS-i-0a0cda5bfc5ca6053-1/assemble-sports/universityoftasmania-livescores-production-vertical-traffic-light/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d7b6d5d"]])

export default __exports__